import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

const useDrawCardContentIdsByCards = (cardIds: string[] | undefined) : string[] | undefined => {
  const drawCardContentDb = useSelector((state: RootState) => state.drawCardContentDb);
  if (cardIds === undefined) return;
  let ids: string[] = [];
  cardIds.forEach(cardId => {
    const itemIds = Object.keys(drawCardContentDb.drawCardContents).filter(id => drawCardContentDb.drawCardContents[id].cardId === cardId);
    ids.push(...itemIds);
  })
  return ids;
}

export default useDrawCardContentIdsByCards;
